export const range = <R, T extends (index: number) => R>(length: number, create: T): R[] =>
  Array.from({ length }, (_, i) => create(i));
